import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import {
  createNewLesson,
  fetchEditLesson,
  fetchLessonList,
} from "../actions/lesson";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Delete } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Editor } from "ckeditor5-custom-build/build/ckeditor";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import InputField from "../components/Admin/Reusable/InputField";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import dayjs from "dayjs";
import { fetchCountryFormList } from "../actions/country";
import { fetchEducationFormList } from "../actions/education";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

const UploadField = ({
  handleFileChange,
  placeholder,
  fieldName,
  className,
}) => {
  return (
    <div className={className}>
      <label>
        <input
          className="test-test"
          id={`file-input-${fieldName}`}
          name={fieldName}
          accept={".jpg,.png"}
          multiple={false}
          type="file"
          hidden
          onChange={handleFileChange}
        />
        <Button
          variant="contained"
          component="span"
          className="default-btn-primary"
          size="small"
          startIcon={<FileUploadRoundedIcon />}
        >
          {placeholder}
        </Button>
      </label>
    </div>
  );
};

const LessonAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  //breadcrumb
  const translateForm = "lessonsForm";
  const translateModule = "lessons";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const initialState = {
    name: "",
    position: "",
    educationId: "",
    description: "",
    status: "ACTIVE",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [countryValue, setCountryValue] = useState("");
  const [image, setImage] = useState(null);

  const { lessonDetail } = useSelector((state) => state.lessonReducer);
  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { educationFormList } = useSelector((state) => state.educationReducer);

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  //pozvati podatke za drzave kako bi izlistali u selektu
  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, [dispatch]);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchLessonList(id));
    }
  }, [id, dispatch]);

  //ako je korisnik setovan da je admin drzave odmah se nakon dobijanja drzava proverava da li je count 1 i odmah je setuje
  useEffect(() => {
    if (countryFormList.length == 1 && !countryValue) {
      const singleCountry = countryFormList[0];
      setCountryValue(singleCountry.id);
      dispatch(fetchEducationFormList(singleCountry.id));
    }
  }, [countryFormList, countryValue, dispatch]);

  useEffect(() => {
    if (lessonDetail && id) {
      setData({
        ...data,
        name: lessonDetail.name || "",
        image: lessonDetail.image || "",
        position: lessonDetail.position || "",
        description: lessonDetail.description || "",
        educationId: lessonDetail.educationId || "",
        status: lessonDetail.status || "ACTIVE",
        createdAt: lessonDetail.createdAt || "",
        updatedAt: lessonDetail.updatedAt || "",
      });
      if (lessonDetail && lessonDetail.countryId) {
        setCountryValue(lessonDetail.countryId);
        dispatch(fetchEducationFormList(lessonDetail.countryId));
      }
    }
  }, [lessonDetail, id, dispatch]);

  const handleFileDelete = (fieldName) => {
    switch (fieldName) {
      case "image":
        setImage(null);
      default:
        break;
    }

    // Resetovanje input polja
    //TODO: Ispraviti da ide preko refa
    document.getElementById(`file-input-${fieldName}`).value = "";
  };

  const handleFileChange = (event) => {
    const name = event.target.name;
    const selectedFile = event.target.files[0];
    if (
      (selectedFile && selectedFile.type === "image/jpeg") ||
      selectedFile.type === "image/png"
    ) {
      switch (name) {
        case "image":
          setImage(selectedFile);
          break;
        default:
          return;
      }
    }
  };

  const clientValidationHandler = () => {
    const { name, position, educationId } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
      position,
      educationId,
      countryValue,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }

    const formData = new FormData();

    formData.append("image", image);
    formData.append("name", data.name);
    formData.append("position", data.position);
    formData.append("description", data.description);
    formData.append("educationId", data.educationId);
    formData.append("status", data.status);

    if (id) {
      formData.append("id", id);
      dispatch(fetchEditLesson(formData, navigate));
    } else {
      if (!image) {
        toast.error("Morate odabrati sliku", { theme: "colored" });
        return;
      }
      dispatch(createNewLesson(formData, navigate));
    }
  };

  const handleChangeCountry = (event) => {
    if (!id) setCountryValue(event.target.value);
    dispatch(fetchEducationFormList(event.target.value));
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        extraTitle={lessonDetail && lessonDetail.name}
        pageType={pageType}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Row>
                    <Col lg={12} md={12} xs={12} className="">
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          <div className="lesson-holder-admin-left-side-text">
                            <Row>
                              <Col lg={12} md={12} xs={12} className="mb-4">
                                <InputField
                                  label="Naziv lekcije"
                                  name="name"
                                  value={data.name}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col>
                              <Col lg={3} md={12} xs={12} className="mb-4">
                                <FormControl
                                  fullWidth
                                  size="small"
                                  error={errors?.countryValue}
                                  disabled={countryFormList?.length == 1}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    Država
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={countryValue}
                                    label="Država"
                                    onChange={handleChangeCountry}
                                    size="small"
                                    disabled={id && true}
                                  >
                                    {countryFormList?.map((item, key) => (
                                      <MenuItem value={item.id} key={key}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {errors?.countryValue && (
                                    <FormHelperText>
                                      obavezno polje
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Col>
                              <Col lg={6} md={12} xs={12} className="mb-3">
                                <FormControl
                                  fullWidth
                                  required
                                  size="small"
                                  error={errors?.educationId ? true : false}
                                >
                                  <InputLabel
                                    id="demo-simple-select-label"
                                    size="small"
                                  >
                                    Edukacija
                                  </InputLabel>
                                  <Select
                                    value={data.educationId}
                                    label="Edukacija"
                                    name="educationId"
                                    onChange={handleInputChange}
                                    size="small"
                                    disabled={
                                      countryValue === "" ||
                                      educationFormList?.length === 0 ||
                                      (id && true)
                                    }
                                  >
                                    {educationFormList?.map((item, key) => (
                                      <MenuItem value={item.id} key={key}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {errors?.educationId && (
                                    <FormHelperText>
                                      obavezno polje
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Col>
                              <Col lg={3} md={12} xs={12} className="mb-4">
                                <InputField
                                  type="number"
                                  label="Pozicija"
                                  name="position"
                                  value={data.position}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col>
                              <Col lg={12} md={12} xs={12}>
                                <InputLabel>Opis</InputLabel>
                                <CKEditor
                                  name="description"
                                  editor={Editor}
                                  data={data.description}
                                  onReady={(editor) => {}}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setData((prevUser) => ({
                                      ...prevUser,
                                      description: data,
                                    }));
                                  }}
                                />
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>Slika</Card.Header>
                        <Card.Body>
                          <UploadField
                            handleFileChange={handleFileChange}
                            placeholder={"Priložite sliku"}
                            fieldName={"image"}
                          />
                          {data.image && (
                            <Col lg={12} md={12} xs={12}>
                              <Fragment>
                                <div className="preview-image-holder-admin">
                                  <img
                                    src={data.image}
                                    alt={data.image?.name}
                                    width={`100%`}
                                  />
                                </div>
                              </Fragment>
                            </Col>
                          )}

                          {image && (
                            <Fragment>
                              <div className="mt-2">
                                Odabrana slika: <b>{image?.name}</b> (Veličina:{" "}
                                {(image?.size / 1048576).toFixed(2)} MB)
                              </div>
                              <div className="preview-image-holder-admin mt-2">
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt={image?.name}
                                  width={`100%`}
                                />
                              </div>
                              <div className="text-end mt-2">
                                <Button
                                  variant="contained"
                                  color="error"
                                  type="button"
                                  size="small"
                                  startIcon={<DeleteIcon />}
                                  onClick={() => handleFileDelete("image")}
                                >
                                  Obriši
                                </Button>
                              </div>
                            </Fragment>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>

                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default LessonAdd;
